<template>
  <div class="newsModal">
    <Modal
      class="common-drawer newModal"
      v-model="value"
      :title="curItemDetail.title"
      width="1000"
      :on-open-modal="(modalShow = true)"
      @on-cancel="onCancel"
    >
      <div class="texts">
        <p v-html="removeSpanTags(curItemDetail.messageContent)"></p>
      </div>
      <div slot="footer" class="footer"></div>
    </Modal>
  </div>
</template>

<script>
import api from "@/api";
import { mapState } from "vuex";
export default {
  props: {
    curItemDetail: Object,

    value: {},
  },
  computed: {
    ...mapState({
      dologwidth: (state) => state.dologwidth,
    }),
  },
  data() {
    return {
      modalShow: false,
      formData: {},
      form: {},
    };
  },
  mounted() {},
  methods: {
    removeSpanTags(inputString) {
      // 使用正则表达式匹配并移除<span>标签及其属性，保留内容
      if (inputString) {
        var resultString = inputString.replace(
          /<span[^>]*>(.*?)<\/span>/g,
          "$1"
        );
        return resultString;
      }
    },
    onCancel() {
      this.form.id = this.curItemDetail.id;
      this.form.messageStatus = "read";

      this.$store.dispatch("newsNum");
      this.$emit("input", false);
    },
  },
};
</script>
<style lang='less' scoped>
.texts {
  text-align: left;
}
.footer {
  text-align: center;
}
</style>